import { render, staticRenderFns } from "./NavigationTile.vue?vue&type=template&id=531df3e6&scoped=true&"
import script from "./NavigationTile.vue?vue&type=script&lang=ts&"
export * from "./NavigationTile.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationTile.vue?vue&type=style&index=0&id=531df3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531df3e6",
  null
  
)

export default component.exports